module.exports = __webpack_public_path__ + "static/img/pro4.6bf890b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pro4.jpg
// module id = 3N6P
// module chunks = 1